import axios from 'axios';

const getStreamateAutologinLink = ({ navigationApiUrl, memberUuid, sessionId, userToken }) => {
    const url = `${navigationApiUrl}/v1/streamate-generate-autologin`;

    return axios.get(url, {
        headers: {
            authorization: userToken,
        },
        params: { memberUuid, sessionId }
    })
        .then(res => res.data);
};

export default getStreamateAutologinLink;
